module.exports = __webpack_public_path__ + "img/AlphaLogo-navbar.62d7cd36.png";